import { type AxiosInstance, type AxiosError, HttpStatusCode } from "axios";
import useSWR from "swr";
import type { KeyedMutator } from "swr";
import type { GetCommercialMonitoringDetailsAPIResponse } from "@/features/commercialRegistrationMonitoring/types";
import { SendToTrackingService } from "@/api/handlers/errors";

interface IResponse {
  data: GetCommercialMonitoringDetailsAPIResponse | undefined;
  isLoading: boolean;
  mutate: KeyedMutator<GetCommercialMonitoringDetailsAPIResponse>;
  error: AxiosError | undefined;
}

export const GetCommercialMonitoringDetailAPI = (
  apiClient: AxiosInstance,
  id: number
): IResponse => {
  const fetcher = async (
    url: string
  ): Promise<GetCommercialMonitoringDetailsAPIResponse> => {
    const { data } =
      await apiClient.get<GetCommercialMonitoringDetailsAPIResponse>(url);
    return data;
  };

  const { data, isLoading, mutate, error } = useSWR<
    GetCommercialMonitoringDetailsAPIResponse,
    AxiosError
  >(
    [`/commercial-monitoring/${id}`],
    async ([url]: [string]) => await fetcher(url),
    {
      // NOTE: バックエンドの120秒制限に合わせる
      errorRetryInterval: 120_000,
      revalidateOnFocus: false,
    }
  );

  if (
    error &&
    (error.response?.status ?? HttpStatusCode.InternalServerError) >=
      HttpStatusCode.InternalServerError
  ) {
    SendToTrackingService(error);
  }

  return { data, isLoading, mutate, error };
};
